module.exports = __webpack_public_path__ + "img/weidu2.c8732ba4.png";